// // src/api/volumeDiscounts.ts

// /**
//  * Volume Discounts API (global helpers)
//  * -------------------------------------
//  * - All helpers return `json?.data ?? json` so you can pass them straight to UI.
//  * - Pass your JWT token per call (or wrap these with your own token provider).
//  * - Uses fetch with robust error handling and optional AbortSignal.
//  */

// export type SortOrder = "asc" | "desc";

// export interface DatatableSort {
//   field: string;
//   order: SortOrder;
// }

// export interface DatatableQuery {
//   search?: string;
//   page?: number;
//   limit?: number;
//   sort?: DatatableSort;
//   // Use any shape you like; backend will decide:
//   filters?: Record<string, any>;
// }

// export type VolumeDiscountStatus = "active" | "inactive" | string;

// export interface VolumeDiscount {
//   id: string;
//   product_id: string;
//   variant_id: string;
//   starting_at: number;        // min qty
//   discount: number;           // numeric value
//   discount_in: string;        // e.g. "%", "flat", etc.
//   status: VolumeDiscountStatus;
//   created_at?: string;
//   updated_at?: string;
//   // backend may include more:
//   [k: string]: any;
// }

// export interface CreateVolumeDiscountPayload {
//   apply_to_all?: boolean;
//   variant_id: string;
//   starting_at: number;
//   discount: number;
//   discount_in: string;        // e.g. "%", "flat", "$"
//   status?: VolumeDiscountStatus;
// }

// export type UpdateVolumeDiscountPayload = Partial<
//   Omit<CreateVolumeDiscountPayload, "variant_id">
// > & {
//   // Some backends use `discount_value` on PATCH:
//   discount_value?: number;
// };

// type Maybe<T> = T | undefined;

// const BASE_URL =
//   (process.env.REACT_APP_API_URL?.replace(/\/+$/, "") ||
//     "http://localhost:5002");

// function joinUrl(...parts: Array<string | number>): string {
//   return parts
//     .map(String)
//     .join("/")
//     .replace(/(?<!:)\/\/+/g, "/"); // avoid double slashes (except after http:)
// }

// async function apiRequest<T>(
//   method: "GET" | "POST" | "PATCH" | "DELETE",
//   url: string,
//   token: string,
//   body?: any,
//   signal?: AbortSignal
// ): Promise<T> {
//   const headers: Record<string, string> = {
//     Authorization: `Bearer ${token}`,
//   };
//   const init: RequestInit = { method, headers, signal };

//   if (body !== undefined) {
//     headers["Content-Type"] = "application/json";
//     init.body = JSON.stringify(body);
//   }

//   const res = await fetch(url, init);

//   let json: any = null;
//   try {
//     json = await res.json();
//   } catch {
//     // ignore JSON parse errors for non-JSON responses
//   }

//   if (!res.ok) {
//     const msg =
//       json?.message ||
//       json?.error ||
//       `Request failed: ${res.status} ${res.statusText}`;
//     const err = new Error(msg) as Error & { status?: number; payload?: any };
//     err.status = res.status;
//     err.payload = json;
//     throw err;
//   }

//   // Most of your APIs return { data: ... }; fall back to raw JSON if not
//   return (json?.data ?? json) as T;
// }

// /**
//  * 1) Create Volume Discount
//  * POST /products/:productId/variants/:variantId/volume-discounts
//  */
// export async function createVolumeDiscount(
//   productId: string,
//   variantId: string,
//   payload: CreateVolumeDiscountPayload,
//   token: string,
//   signal?: AbortSignal
// ): Promise<VolumeDiscount> {
//   const url = joinUrl(
//     BASE_URL,
//     "products",
//     productId,
//     "variants",
//     variantId,
//     "volume-discounts"
//   );
//   return apiRequest<VolumeDiscount>("POST", url, token, payload, signal);
// }

// /**
//  * 2) Get All Discounts By Variant
//  * GET /products/:productId/variants/:variantId/volume-discounts
//  */
// export async function getVariantDiscounts(
//   productId: string,
//   variantId: string,
//   token: string,
//   signal?: AbortSignal
// ): Promise<VolumeDiscount[]> {
//   const url = joinUrl(
//     BASE_URL,
//     "products",
//     productId,
//     "variants",
//     variantId,
//     "volume-discounts"
//   );
//   return apiRequest<VolumeDiscount[]>("GET", url, token, undefined, signal);
// }

// /**
//  * 3) Get One Discount
//  * GET /products/:productId/variants/:variantId/volume-discounts/:id
//  */
// export async function getOneDiscount(
//   productId: string,
//   variantId: string,
//   discountId: string,
//   token: string,
//   signal?: AbortSignal
// ): Promise<VolumeDiscount> {
//   const url = joinUrl(
//     BASE_URL,
//     "products",
//     productId,
//     "variants",
//     variantId,
//     "volume-discounts",
//     discountId
//   );
//   return apiRequest<VolumeDiscount>("GET", url, token, undefined, signal);
// }

// /**
//  * 4) Update Volume Discount (PATCH)
//  * PATCH /volume-discounts/:id
//  */
// export async function updateVolumeDiscount(
//   discountId: string,
//   payload: UpdateVolumeDiscountPayload,
//   token: string,
//   signal?: AbortSignal
// ): Promise<VolumeDiscount> {
//   const url = joinUrl(BASE_URL, "volume-discounts", discountId);
//   return apiRequest<VolumeDiscount>("PATCH", url, token, payload, signal);
// }

// /**
//  * 5) Delete Volume Discount
//  * DELETE /volume-discounts/:id
//  */
// export async function deleteVolumeDiscount(
//   discountId: string,
//   token: string,
//   signal?: AbortSignal
// ): Promise<{ deleted: boolean } | Record<string, any>> {
//   // Note: fixed potential double-slash from sample (`/api/v1//volume-discounts/...`)
//   const url = joinUrl(BASE_URL, "volume-discounts", discountId);
//   return apiRequest("DELETE", url, token, undefined, signal);
// }

// /**
//  * 6) Get All Variant Discounts (Data Table)
//  * POST /products/:productId/volume-discounts/datatable
//  */
// export async function getVariantDiscountsDatatable(
//   productId: string,
//   body: DatatableQuery,
//   token: string,
//   signal?: AbortSignal
// ): Promise<{
//   data: VolumeDiscount[];
//   page?: number;
//   limit?: number;
//   total?: number;
//   totalPages?: number;
//   // some APIs include extra sections like "cards"
//   [k: string]: any;
// }> {
//   const url = joinUrl(
//     BASE_URL,
//     "products",
//     productId,
//     "volume-discounts",
//     "datatable"
//   );
//   return apiRequest("POST", url, token, body, signal);
// }

// /* ------------------------------------------------------------------ */
// /* Optional: tiny convenience layer if you prefer not passing token
//    everywhere; you can set it once and use the ".withToken" helpers.  */
// /* ------------------------------------------------------------------ */
// export const VolumeDiscounts = {
//   create: createVolumeDiscount,
//   listByVariant: getVariantDiscounts,
//   getOne: getOneDiscount,
//   update: updateVolumeDiscount,
//   remove: deleteVolumeDiscount,
//   datatable: getVariantDiscountsDatatable,

//   withToken(token: string) {
//     return {
//       create: (productId: string, variantId: string, payload: CreateVolumeDiscountPayload, signal?: AbortSignal) =>
//         createVolumeDiscount(productId, variantId, payload, token, signal),
//       listByVariant: (productId: string, variantId: string, signal?: AbortSignal) =>
//         getVariantDiscounts(productId, variantId, token, signal),
//       getOne: (productId: string, variantId: string, discountId: string, signal?: AbortSignal) =>
//         getOneDiscount(productId, variantId, discountId, token, signal),
//       update: (discountId: string, payload: UpdateVolumeDiscountPayload, signal?: AbortSignal) =>
//         updateVolumeDiscount(discountId, payload, token, signal),
//       remove: (discountId: string, signal?: AbortSignal) =>
//         deleteVolumeDiscount(discountId, token, signal),
//       datatable: (productId: string, body: DatatableQuery, signal?: AbortSignal) =>
//         getVariantDiscountsDatatable(productId, body, token, signal),
//     };
//   },
// };



// Volumediscountcalls.tsx  (a.k.a. src/api/volumeDiscounts.ts)
//
// ✅ Matches your 4 calls:
// 1) Create Volume Discount
// 4) Update Volume Discount (PATCH)
// 5) Delete Volume Discount
// 6) Get All Variant Discounts (Data Table)
//
// Notes:
// - Support BOTH discount *or* fixed price:
//     • When “Leave initial price” = true → send { discount, discount_in }
//     • When unchecked (fixed price)     → send { fixed_price }
// - Always set `apply_to_all` in the UI; helpers are neutral (but allowed).
// - `discount_in` must be "%", "$" or "flat". No "$" string.
// - `token` can be string | null; header is only added if truthy.

import { showSuccess, showError } from "toast/toast";
import { handleApiError } from "utils/errorHandler";
import { getAuthCookie } from "../utils/authCookies";
export type SortOrder = "asc" | "desc";

export interface DatatableSort {
  field: string;
  order: SortOrder;
}

export interface DatatableQuery {
  search?: string;
  page?: number;
  limit?: number;
  sort?: DatatableSort;
  filters?: Record<string, any>;
}

export type VolumeDiscountStatus = "active" | "inactive" | string;
export type DiscountIn = "%" | "$" 

export interface VolumeDiscount {
  id: string;
  product_id: string;
  variant_id: string;
  starting_at?: number;   // min qty (from assignment) - deprecated, use discount.starting_at
  discount: number | {   // numeric value OR nested discount object
    _id?: string;
    name?: string;
    starting_at: number;  // min qty (from discount) - use this one
    discount: number;
    discount_in: DiscountIn;
    status?: VolumeDiscountStatus;
    [k: string]: any;
  };
  discount_in?: DiscountIn;
  status: VolumeDiscountStatus;
  created_at?: string;
  updated_at?: string;
  [k: string]: any;
}

// Helper function to get starting_at from discount object
export function getStartingAt(d: VolumeDiscount): number {
  if (typeof d.discount === 'object' && d.discount !== null && 'starting_at' in d.discount) {
    return Number(d.discount.starting_at || 1);
  }
  return Number(d.starting_at || 1);
}

// CREATE payload: either discount OR fixed_price
export interface CreateVolumeDiscountPayload {
  apply_to_all?: boolean;
  variant_id: string;
  starting_at: number;

  // one of these branches:
  discount?: number;          // when leaving initial price
  discount_in?: DiscountIn;   // "%", "$", "flat"

  fixed_price?: number;       // when NOT leaving initial price

  status?: VolumeDiscountStatus;
}

// PATCH payload: backend may expect discount_value for discount updates
export type UpdateVolumeDiscountPayload = Partial<
  Omit<CreateVolumeDiscountPayload, "variant_id">
> & {
  discount_value?: number; // PATCH form for discount updates
};

const BASE_URL =
  (process.env.REACT_APP_API_URL?.replace(/\/+$/, "") ||
    "http://localhost:5002");

// Join segments and collapse duplicate slashes (keeps http://)
function joinUrl(...parts: Array<string | number>): string {
  return parts
    .map(String)
    .join("/")
    .replace(/(?<!:)\/\/+/g, "/");
}

async function apiRequest<T>(
  method: "GET" | "POST" | "PATCH" | "DELETE",
  url: string,
  token?: string | null,
  body?: any,
  signal?: AbortSignal
): Promise<T> {
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const init: RequestInit = { method, headers, signal };
  if (body !== undefined) {
    headers["Content-Type"] = "application/json";
    init.body = JSON.stringify(body);
  }

  const res = await fetch(url, init);

  let json: any = null;
  try {
    json = await res.json();
  } catch {
    // non-JSON response; leave json as null
  }

  if (!res.ok) {
    const msg =
      json?.message ||
      json?.error ||
      `Request failed: ${res.status} ${res.statusText}`;
    const err = new Error(msg) as Error & { status?: number; payload?: any };
    err.status = res.status;
    err.payload = json;
    throw err;
  }

  return (json?.data ?? json) as T;
}

/**
 * 1) Create Volume Discount
 * POST /products/:productId/variants/:variantId/volume-discounts
 */
export async function createVolumeDiscount(
  productId: string,
  variantId: string,
  payload: CreateVolumeDiscountPayload,
  token?: string | null,
  signal?: AbortSignal
): Promise<VolumeDiscount> {
  const userId = getAuthCookie("userId");
  const licenseType = getAuthCookie("licenseType");
  const userName = getAuthCookie("userName");
  const url = joinUrl(
    BASE_URL,
    "products",
    productId,
    "variants",
    variantId,
    "volume-discounts"
  );
  // normalize discount_in if user accidentally sent "$"
  if ((payload as any)?.discount_in === "$") {
    (payload as any).discount_in = "$";
  }
  
  try {
    showSuccess("Volume Create Successfully");
    return await apiRequest<VolumeDiscount>("POST", url, token, payload, signal);
  } catch (error) {
    await handleApiError(error, {
      module: "other",
      action: "Volumediscountcalls_create_volume_discount",
      userId: userId || undefined,
      licenseType: licenseType || undefined,
      userName: userName || undefined,
      url,
      method: "POST",
      requestBody: payload,
      // headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      additionalInfo: {
        productId,
        variantId,
      },
    }, token || null);
    throw error;
  }
}

/**
 * 4) Update Volume Discount (PATCH)
 * PATCH /volume-discounts/:id
 */
export async function updateVolumeDiscount(
  discountId: string,
  payload: UpdateVolumeDiscountPayload,
  token?: string | null,
  signal?: AbortSignal
): Promise<VolumeDiscount> {
  const userId = getAuthCookie("userId");
  const licenseType = getAuthCookie("licenseType");
  const userName = getAuthCookie("userName");
  const url = joinUrl(BASE_URL, "volume-discounts", discountId);
  if ((payload as any)?.discount_in === "$") {
    (payload as any).discount_in = "$";
  }
  
  try {
    showSuccess("Volume Updated Successfully");
    return await apiRequest<VolumeDiscount>("PATCH", url, token, payload, signal);
  } catch (error) {
    await handleApiError(error, {
      module: "other",
      action: "Volumediscountcalls_update_volume_discount",
      userId: userId || undefined,
      licenseType: licenseType || undefined,
      userName: userName || undefined,
      url,
      method: "PATCH",
      requestBody: payload,
      // headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      additionalInfo: {
        discountId,
      },
    }, token || null);
    throw error;
  }
}

/**
 * 5) Delete Volume Discount
 * DELETE /volume-discounts/:id
 */
export async function deleteVolumeDiscount(
  discountId: string,
  token?: string | null,
  signal?: AbortSignal
): Promise<{ deleted: boolean } | Record<string, any>> {
  const userId = getAuthCookie("userId");
  const licenseType = getAuthCookie("licenseType");
  const userName = getAuthCookie("userName");
  const url = joinUrl(BASE_URL, "volume-discounts", discountId);
  
  try {
    showSuccess("Volume deleted Successfully");
    return await apiRequest("DELETE", url, token, undefined, signal);
  } catch (error) {
    await handleApiError(error, {
      module: "other",
      action: "Volumediscountcalls_delete_volume_discount",
      userId: userId || undefined,
      licenseType: licenseType || undefined,
      userName: userName || undefined,
      url,
      method: "DELETE",
      // headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      additionalInfo: {
        discountId,
      },
    }, token || null);
    throw error;
  }
}

/**
 * 6) Get All Variant Discounts (Data Table)
 * POST /products/:productId/volume-discounts/datatable
 */
export async function getVariantDiscountsDatatable(
  productId: string,
  body: DatatableQuery,
  token?: string | null,
  signal?: AbortSignal
): Promise<{
  data: VolumeDiscount[];
  page?: number;
  limit?: number;
  total?: number;
  totalPages?: number;
  [k: string]: any;
}> {
  const userId = getAuthCookie("userId");
  const licenseType = getAuthCookie("licenseType");
  const userName = getAuthCookie("userName");
  const url = joinUrl(
    BASE_URL,
    "products",
    productId,
    "volume-discounts",
    "datatable"
  );
  
  try {
    showSuccess("Volume data added table inside Successfully");
    return await apiRequest("POST", url, token, body, signal);
  } catch (error) {
    await handleApiError(error, {
      module: "other",
      action: "Volumediscountcalls_get_variant_discounts_datatable",
      userId: userId || undefined,
      licenseType: licenseType || undefined,
      userName: userName || undefined,
      url,
      method: "POST",
      requestBody: body,
      // headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      additionalInfo: {
        productId,
      },
    }, token || null);
    throw error;
  }
}

// ADD to src/api/volumeDiscounts.ts

/** 2) Get ALL discounts for a variant */
export async function getDiscountsByVariant(
  productId: string,
  variantId: string,
  token?: string | null,
  signal?: AbortSignal
): Promise<VolumeDiscount[]> {
  const userId = getAuthCookie("userId");
  const licenseType = getAuthCookie("licenseType");
  const userName = getAuthCookie("userName");
  const url = joinUrl(
    BASE_URL,
    "products",
    productId,
    "variants",
    variantId,
    "volume-discount-assignments"
  );
  
  try {
    // returns VolumeDiscount[] (or {data: VolumeDiscount[]})
    const res = await apiRequest<any>("GET", url, token, undefined, signal);
    return (Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : []) as VolumeDiscount[];
  } catch (error) {
    await handleApiError(error, {
      module: "other",
      action: "Volumediscountcalls_get_discounts_by_variant",
      userId: userId || undefined,
      licenseType: licenseType || undefined,
      userName: userName || undefined,
      url,
      method: "GET",
      // headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      additionalInfo: {
        productId,
        variantId,
      },
    }, token || null);
    throw error;
  }
}

/** 3) Get ONE discount for a variant */
export async function getDiscountById(
  productId: string,
  variantId: string,
  discountId: string,
  token?: string | null,
  signal?: AbortSignal
): Promise<VolumeDiscount> {
  const userId = getAuthCookie("userId");
  const licenseType = getAuthCookie("licenseType");
  const userName = getAuthCookie("userName");
  const url = joinUrl(
    BASE_URL,
    "products",
    productId,
    "variants",
    variantId,
    "volume-discount-assignments",
    discountId
  );
  
  try {
    const res = await apiRequest<any>("GET", url, token, undefined, signal);
    return (res?.data ?? res) as VolumeDiscount;
  } catch (error) {
    await handleApiError(error, {
      module: "other",
      action: "Volumediscountcalls_get_discount_by_id",
      userId: userId || undefined,
      licenseType: licenseType || undefined,
      userName: userName || undefined,
      url,
      method: "GET",
      // headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      additionalInfo: {
        productId,
        variantId,
        discountId,
      },
    }, token || null);
    throw error;
  }
}


/* Convenience wrapper if you prefer to set token once */
export const VolumeDiscounts = {
  create: createVolumeDiscount,
  update: updateVolumeDiscount,
  remove: deleteVolumeDiscount,
  datatable: getVariantDiscountsDatatable,

  withToken(token?: string | null) {
    return {
      create: (productId: string, variantId: string, payload: CreateVolumeDiscountPayload, signal?: AbortSignal) =>
        createVolumeDiscount(productId, variantId, payload, token, signal),
      update: (discountId: string, payload: UpdateVolumeDiscountPayload, signal?: AbortSignal) =>
        updateVolumeDiscount(discountId, payload, token, signal),
      remove: (discountId: string, signal?: AbortSignal) =>
        deleteVolumeDiscount(discountId, token, signal),
      datatable: (productId: string, body: DatatableQuery, signal?: AbortSignal) =>
        getVariantDiscountsDatatable(productId, body, token, signal),
    };
  },
};
